<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Vehicle Maintenance</h4>
    <hr >
    <b-row class="justify-content-md-center">
      <b-col md="8">
        <spinner v-if="isFetching" />

        <b-alert
          :show="!isFetching && !assignments.length && steps === 1"
          variant="info">
          You have no assignments.
        </b-alert>

        <div v-if="!isFetching">
          <cleaning-form-1 v-if="steps === 1 && assignments.length"/>
          <cleaning-form-2 v-if="steps === 2"/>
          <cleaning-form-3 v-if="steps === 3"/>
        </div>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Spinner from '@/components/Spinner'
import CleaningForm1 from './CleaningForm1.vue'
import CleaningForm2 from './CleaningForm2.vue'
import CleaningForm3 from './CleaningForm3.vue'
import { toastr } from '@/services/'
import { sendEvent } from '@/services/socket'

export default {
  name: 'Cleaning',
  components: {
    Spinner,
    CleaningForm1,
    CleaningForm2,
    CleaningForm3
  },
  data () {
    return {
      isFetching: false
    }
  },
  computed: {
    ...mapState('cleaning', [
      'assignments',
      'stations',
      'steps'
    ])
  },
  created () {
    // if there's unlocked cars in localStorage, show cleaner form 3
    if (localStorage.unlockedCars) {
      this.$store.commit('cleaning/setSteps', 3)
    } else {
      this.init()
    }
    sendEvent('CLEANER_EVENT', { page: '/cleaning', eventName: 'PAGE_ACCESS' })
  },
  methods: {
    init () {
      this.$store.commit('cleaning/setSteps', 1)
      this.isFetching = true
      Promise.all([
        this.$store.dispatch('cleaning/fetchZones'),
        this.$store.dispatch('cleaning/fetchStations'),
        this.$store.dispatch('cleaning/fetchCars'),
        this.$store.dispatch('cleaning/fetchCarInStations'),
        this.$store.dispatch('cleaning/fetchAssignments')
      ]).then(
        () => {
          if (this.assignments.length) {
            this.$store.dispatch('cleaning/filterStationsAndCars')
          }
          this.isFetching = false
        },
        () => {
          toastr.serverError()
        }
      )
    }
  },
}
</script>
